import { Injectable } from '@angular/core';
import { generateClient } from '@aws-amplify/api';
import * as queries from '@app/core/graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreateProposalsInput,
    DeleteProposalsInput,
    Proposals,
    UpdateProposalsInput
} from '@app/core/services/api/API.service';

@Injectable({
    providedIn: 'root'
})
export class ProposalsService {
    private amplifyClient = generateClient();

    constructor() {}

    async listProposal(): Promise<Proposals[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listProposals
                })
            ).data.listProposals.items;
            if (data) return data as Proposals[];
        } catch (error) {
            console.error('Error finding Proposal:', error);
            return null;
        }
    }

    async createProposal(input: CreateProposalsInput): Promise<Proposals> {
        try {
            const proposals = (
                await this.amplifyClient.graphql({
                    query: mutations.createProposals,
                    variables: {
                        input
                    }
                })
            ).data.createProposals;
            if (proposals) return proposals as Proposals;
        } catch (error) {
            console.error('Error creating proposals', error);
            return null;
        }
    }

    async updateProposals(input: UpdateProposalsInput): Promise<Proposals> {
        try {
            const proposals = (
                await this.amplifyClient.graphql({
                    query: mutations.updateProposals,
                    variables: { input }
                })
            ).data.updateProposals;
            if (proposals) return proposals as Proposals;
        } catch (error) {
            console.error('Error updating proposals', error);
            return null;
        }
    }

    async deleteProposals(input: DeleteProposalsInput): Promise<Proposals> {
        try {
            const proposals = (
                await this.amplifyClient.graphql({
                    query: mutations.deleteProposals,
                    variables: { input }
                })
            ).data.deleteProposals;
            if (proposals) return proposals as Proposals;
        } catch (error) {
            console.error('Error deleting proposals', error);
            return null;
        }
    }
}
